import { render, staticRenderFns } from "./ChineseRepast.vue?vue&type=template&id=77819caa&scoped=true&"
import script from "./ChineseRepast.vue?vue&type=script&lang=js&"
export * from "./ChineseRepast.vue?vue&type=script&lang=js&"
import style0 from "./ChineseRepast.vue?vue&type=style&index=0&id=77819caa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77819caa",
  null
  
)

export default component.exports